import { useEffect, useMemo } from "react"
import { readLaunchCache, writeLaunchCache } from "~/lib/launch-cache"
import { api } from "~/trpc/react"

export function useLaunchPath(userId: string | undefined, orgSlug?: string) {
	const cached = useMemo(
		() => (userId ? readLaunchCache(userId, orgSlug) : null),
		[userId, orgSlug]
	)
	const launch = api.user.getLaunchPath.useQuery(
		orgSlug ? { orgSlug } : undefined,
		{
			enabled: !!userId && !cached,
			staleTime: 0
		}
	)
	useEffect(() => {
		if (userId && !cached && launch.isSuccess && !launch.isFetching)
			writeLaunchCache(userId, launch.data)
	}, [userId, cached, launch.isSuccess, launch.isFetching, launch.data])
	return {
		path: cached ?? launch.data,
		isLoading: !cached && (launch.isPending || launch.isFetching),
		isSuccess: !!cached || launch.isSuccess
	}
}
